import { HBO, HLS_ENCODE, TOOLBOX_MAP } from 'containers/Player/constants';
import shaka from 'shaka-player';

import {
  HBOHLSFairPlayResponseFilter,
  HLSFairPlayResponseFilter,
  HLSFairPlayResponseToolboxFilter,
  HLSFairPlayToolboxRequestFilter,
} from './filters';
import {
  getLiveVTTContent,
  transformLiveSubtitles,
} from '../components/helpers/liveSubtitles';
import { findByArrOfWords } from '../utils/findByArrOfWords';

const wordsToFind = ['textstream', '.m4s'];
import { arrBufferToString, stringToArrBuffer } from './arrayBufferEncoders';

const HBOResponseFilter = (type, response, streamType, isLive) => {
  //LIVE SUBTITLES
  if (findByArrOfWords(response?.uri, wordsToFind)) {
    transformLiveSubtitles(response.data);
  }

  if (streamType.includes(HLS_ENCODE)) {
    // HLS solo funciona con FairPlay.
    return HBOHLSFairPlayResponseFilter(type, response);
  }
  return () => {};
};


const toolboxResponseFilter = (
  isLive,
  type,
  response,
  media,
  _,
  streamType,
  skdUri,
) => {
  //LIVE SUBTITLES
  if (findByArrOfWords(response?.uri, wordsToFind)) {
    sessionStorage.setItem('subtitlesType', 'BASE64');
    transformLiveSubtitles(response.data);
  }

  if (isLive && response?.uri.includes('.vtt')) {
    return
  }

  // Next logic is used to intercept vtt files and replace size property to 100% on the over 100% ones.
  // Need to condition de reponse type by uri that includes .vtt extension.
  if (response?.uri?.toLowerCase().includes('.vtt')) {
    const decoder = new TextDecoder();
    const encoder = new TextEncoder();
    const regex = /size:\d{3}%/gi;
    response.data = encoder?.encode(
      decoder?.decode(response?.data)?.replaceAll(regex, 'size:100%'),
    );
  }
  if (response?.uri.includes('subs.clarovideo')) {
    let subtitles = arrBufferToString(response.data).replace(
      /<br\s*\/?>/gi,
      '_',
    );
    response.data = stringToArrBuffer(subtitles);
  }
  if (type === shaka.net.NetworkingEngine.RequestType.MANIFEST) {
    response.headers.date = response.headers['last-modified'];
    return () => {};
  }
  if (streamType.includes(HLS_ENCODE)) {
    // HLS solo funciona con FairPlay.
    return HLSFairPlayResponseToolboxFilter(type, response, media, skdUri);
  }
  return () => {};
};

const responseFilter = (
  isLive,
  type,
  response,
  media,
  _,
  streamType,
  skdUri,
) => {
  //LIVE SUBTITLES
  if (findByArrOfWords(response?.uri, wordsToFind)) {
    sessionStorage.setItem('subtitlesType', 'BASE64');
    transformLiveSubtitles(response.data);
  }

  if (isLive && response?.uri.includes('.vtt')) {
    return
  }

  // Next logic is used to intercept vtt files and replace size property to 100% on the over 100% ones.
  // Need to condition de reponse type by uri that includes .vtt extension.
  if (response?.uri?.toLowerCase().includes('.vtt')) {
    const decoder = new TextDecoder();
    const encoder = new TextEncoder();
    const regex = /size:\d{3}%/gi;
    response.data = encoder?.encode(
      decoder?.decode(response?.data)?.replaceAll(regex, 'size:100%'),
    );
  }
  if (response?.uri.includes('subs.clarovideo')) {
    let subtitles = arrBufferToString(response.data).replace(
      /<br\s*\/?>/gi,
      '_',
    );
    response.data = stringToArrBuffer(subtitles);
  }
  if (type === shaka.net.NetworkingEngine.RequestType.MANIFEST) {
    response.headers.date = response.headers['last-modified'];
    return () => {};
  }
  if (streamType.includes(HLS_ENCODE)) {
    // HLS solo funciona con FairPlay.
    return HLSFairPlayResponseFilter(type, response, media, skdUri);
  }
  return () => {};
};

const getFilters = config => (type, response) => {
  const { provedorCode, deviceId, media, streamType, isLive } = config;
  if(!isLive && TOOLBOX_MAP[provedorCode]) return toolboxResponseFilter(isLive, type, response, media, deviceId, streamType);

  if (!isLive && provedorCode === HBO) {
    return HBOResponseFilter(type, response, streamType, isLive);
  }
  
  return responseFilter(isLive, type, response, media, deviceId, streamType);
};

export default getFilters;
